import React, { useRef } from 'react'
import fetchData from 'utils/fetchData';
import { toast } from "react-hot-toast";
import { useBigContext } from 'utils/bigContext';
import Tooltip from "components/Tooltip/Tooltip";
import { FaDownload, FaPrint, FaUpload } from 'react-icons/fa';

export default function ReportTemplateControls(props) {
    const { repxName, onCreateXml, onCreatePdf } = props;
    const refFile = useRef();
    const { bigContextState } = useBigContext();

    const onDownloadPdf = async () => {
        if (onCreatePdf == null) {
            toast.error('onDownloadPdf must be set 1st');
            return;
        }

        try {
            var pResponse = await onCreatePdf();
        } catch (error) {
            var pMsg = error.errorMessage;
            if (pMsg == null)
                pMsg = error;
            toast.error(pMsg);
            return;
        }
        if (pResponse.success) {
            var pUrl = window.globalConfig.BASE_URL2 + '/api/View/' + pResponse.content;
            window.open(pUrl, '_blank');
        } else
            toast.error(pResponse);
    }

    const onDownloadXmlClick = async () => {
        if (onCreateXml == null) {
            toast.error('onCreateXml must be set 1st');
            return;
        }

        var pResponse = await onCreateXml();
        if (pResponse.success) {
            var pUrl = window.globalConfig.BASE_URL2 + '/api/Downloads/' + pResponse.content;
            window.open(pUrl, '_blank');
        } else
            toast.error(pResponse);
    };

    const onDownloadRepxClick = async () => {

        var pRepxName = repxName;
        if (repxName instanceof Function)
            pRepxName = repxName();

        var pUrl = window.globalConfig.BASE_URL2 + '/api/ReportTemplates/Download/' + pRepxName;
        window.open(pUrl, '_blank');
    };

    const onUploadRepx = async () => {
        const formData = new FormData();
        var pRepxName = repxName;
        if (repxName instanceof Function)
            pRepxName = repxName();
        formData.append('RepxName', pRepxName);
        formData.append('file', refFile.current.files[0]);
        try {
            var pResponse = await fetch(window.globalConfig.BASE_URL2 + '/api/ReportTemplates/Upload', {
                method: "post",
                body: formData,
                credentials: 'include',
            });
            if (pResponse.ok)
                toast.success('Repx was uploaded successfully.');
            else {
                var pError = await pResponse.text();
                toast.error(pError);
            }
        } catch (error) {
            toast.error(error);
        }
        refFile.current.value = null;
    };

    const allowUpload = () => {
        return bigContextState?.roleTasks?.indexOf('F33751A5-4025-447C-B09D-F90928A9B8E1') >= 0;
    };

    return (
        <div className='flex gap-5'>
            {allowUpload() &&
                <>
                    <button
                        onClick={() => {
                            refFile.current.click();
                        }}
                        class="flex self-center"
                    >
                        <Tooltip text="Upload REPX">
                            <FaUpload className="text-primary w-6 h-6" />
                        </Tooltip>
                    </button>
                    <input ref={refFile} type='file' onChange={onUploadRepx} hidden accept='.repx' />

                    <button
                        onClick={onDownloadRepxClick}

                        class="flex self-center"
                    >
                        <Tooltip text="Download REPX">
                            <FaDownload className="text-primary w-6 h-6" />
                        </Tooltip>
                    </button>

                    <button
                        onClick={onDownloadXmlClick}

                        class="flex self-center"
                    >
                        <Tooltip text="Download XML">
                            <FaDownload className="text-primary w-6 h-6" />
                        </Tooltip>
                    </button>
                </>
            }
            <button
                onClick={onDownloadPdf}
                className="flex self-center"
            >
                <Tooltip text="View PDF">
                    <FaPrint className="w-5 h-5" />
                </Tooltip>
            </button>
        </div>
    )
}
